'use memo';

import type { ListContractAlertsQuery } from '@standandforce/api-contract';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { orpc } from '@/lib/api/orpc';
import { QUERY_PRESETS } from '@/lib/query';
export type { ContractAlertItem, ListContractAlertsQuery } from '@standandforce/api-contract';
export function useContractAlerts(params: ListContractAlertsQuery) {
  return useQuery({
    ...orpc.contractAlert.list.queryOptions({
      input: params
    }),
    ...QUERY_PRESETS.list(),
    // ページ送り・フィルタ・ソートで queryKey が変わっても直前ページのデータを保持し、
    // 再取得中に data が undefined となって総ページ数・件数が一瞬ちらつくのを防ぐ。
    placeholderData: keepPreviousData
  });
}
export function useContractAlertCount() {
  return useQuery({
    ...orpc.contractAlert.count.queryOptions({}),
    ...QUERY_PRESETS.list()
  });
}